import { useTranslation } from 'react-i18next';

import { Row, Col, PaymentLogo } from '@ctct/presentation-layer';

import type { PaymentMethodsLoadedProps } from '../widgets/PaymentMethodsWidget/types';

export function CreditCardSavedPaymentMethod({
  creditCardBrandDisplayName,
  creditCardType,
  formattedCardNumber,
  expirationDate,
  logoName,
  actions,
}: {
  creditCardBrandDisplayName?: string;
  creditCardType?: string;
  formattedCardNumber?: string;
  expirationDate?: string;
  logoName?: ReturnType<PaymentMethodsLoadedProps['data']['getCreditCardLogoName']>;
  actions?: React.ReactNode;
}) {
  const { t } = useTranslation();

  return (
    <Row>
      <Col fixed>
        <span>
          {creditCardBrandDisplayName} {t('payment-methods.credit_card_number')} <strong>{formattedCardNumber}</strong>
        </span>
        <br />
        <span>{`${t('payment-methods.credit_card_expiration_date')} ${expirationDate}`}</span>
      </Col>
      <Col>{logoName && <PaymentLogo image={logoName} alt={`${creditCardType} logo`} />}</Col>
      {actions && <Col>{actions}</Col>}
    </Row>
  );
}
